import { Infinity as InfinityIcon } from "lucide-react";
import { useUsage } from "@/lib/usage";

const R = 15.915; // circumference = 100

export default function DraftsLeftRing({ size = 64, testid = "drafts-left-ring" }) {
  const { used, limit, isPro, loading, plan } = useUsage();
  if (loading || plan === "free") return null;
  if (isPro || !limit) {
    return (
      <div className="inline-flex items-center gap-1.5 rounded-full bg-amber-50 px-3 py-1.5 text-xs font-semibold text-amber-700" data-testid={`${testid}-unlimited`}>
        <InfinityIcon className="h-4 w-4" /> Unlimited AI drafts
      </div>
    );
  }
  const left = Math.max(0, limit - used);
  const pctLeft = Math.round((left / limit) * 100);
  const color = pctLeft <= 0 ? "#E11D48" : pctLeft <= 20 ? "#F59E0B" : "#0053DA";

  return (
    <div className="inline-flex items-center gap-3" data-testid={testid}>
      <svg width={size} height={size} viewBox="0 0 36 36" role="img" aria-label={`${left} of ${limit} AI drafts left`}>
        <circle cx="18" cy="18" r={R} fill="none" stroke="#E2E8F0" strokeWidth="4" />
        <circle cx="18" cy="18" r={R} fill="none" stroke={color} strokeWidth="4" strokeLinecap="round"
          strokeDasharray={`${pctLeft} ${100 - pctLeft}`} strokeDashoffset="25"
          style={{ transition: "stroke-dasharray 600ms ease" }} />
        <text x="18" y="20.5" textAnchor="middle" className="fill-slate-900 font-bold" fontSize="9">{left}</text>
      </svg>
      <div className="leading-tight">
        <p className="text-sm font-semibold text-slate-900" data-testid={`${testid}-left`}>{left} AI drafts left</p>
        <p className="text-xs text-slate-500" data-testid={`${testid}-used`}>{used} used of {limit} this month</p>
      </div>
    </div>
  );
}
